import { render } from "./CZGraphs.vue?vue&type=template&id=04362898&scoped=true&ts=true"
import script from "./CZGraphs.vue?vue&type=script&lang=ts"
export * from "./CZGraphs.vue?vue&type=script&lang=ts"

import "./CZGraphs.vue?vue&type=style&index=0&id=04362898&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04362898"]])

export default __exports__